// extracted by mini-css-extract-plugin
module.exports = {"errorClass":"GSuiteAsidePanel__errorClass","instructions":"GSuiteAsidePanel__instructions","logo":"GSuiteAsidePanel__logo"};